export const dividerTheme = {
  horizontal: {
    margin: 'var(--rem) var(--reset)',
    padding: '0 var(--rem)',
    content: {
      padding: '0 var(--half-rem)',
    },
  },
  vertical: {
    margin: '0 var(--rem)',
    padding: 'var(--rem) var(--reset)',
    content: {
      padding: 'var(--half-rem) var(--reset)',
    },
  },
  colorScheme: {
    light: {
      root: {
        borderColor: 'var(--surface-300)',
      },
      content: {
        background: 'var(--white)',
      },
    },
    dark: {
      root: {
        borderColor: 'var(--p-surface-700)',
      },
      content: {
        background: 'var(--transparent)',
      },
    },
  },
};
